webpackJsonp([46372528695858],{

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.HTMLContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var content = _ref.content,
	      className = _ref.className;
	  return _react2.default.createElement(
	    "div",
	    { className: className },
	    content
	  );
	};
	
	var HTMLContent = exports.HTMLContent = function HTMLContent(_ref2) {
	  var content = _ref2.content,
	      className = _ref2.className;
	  return _react2.default.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: content } });
	};

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: #f8fcff;\n  border: 1px solid rgba(151, 151, 151, 0.06);\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n"], ["\n  background: #f8fcff;\n  border: 1px solid rgba(151, 151, 151, 0.06);\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledWrap = function StyledWrap(props) {
	  return _react2.default.createElement(
	    Wrap,
	    props,
	    props.children
	  );
	};
	
	exports.default = StyledWrap;
	
	// Styled Components
	
	var Wrap = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	module.exports = exports["default"];

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = exports.PageTemplate = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 800px;\n  width: 100%;\n"], ["\n  max-width: 800px;\n  width: 100%;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: -12px;\n  top: -12px;\n  transform: scale(0.8);\n\n  @media (min-width: 48em) {\n    left: 26px;\n    top: 26px;\n    transform: scale(1);\n  }\n"], ["\n  position: absolute;\n  left: -12px;\n  top: -12px;\n  transform: scale(0.8);\n\n  @media (min-width: 48em) {\n    left: 26px;\n    top: 26px;\n    transform: scale(1);\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _rebass = __webpack_require__(3);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(150);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Header = __webpack_require__(108);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Connect = __webpack_require__(29);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _Circle = __webpack_require__(6);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	var _StyledWrap = __webpack_require__(109);
	
	var _StyledWrap2 = _interopRequireDefault(_StyledWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var PageTemplate = exports.PageTemplate = function PageTemplate(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent;
	
	  var PageContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    _rebass.Box,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { htmlAttributes: { class: "internal-page" } }),
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        _StyledWrap2.default,
	        { px: [3, 3, 4, 6], mb: [5, 5, 6] },
	        _react2.default.createElement(_Header2.default, { title: title, my: [5, 5, 6] }),
	        _react2.default.createElement(
	          ContentBox,
	          { mx: "auto", mb: [5, 5, 6] },
	          _react2.default.createElement(PageContent, { className: "content", content: content })
	        ),
	        _react2.default.createElement(
	          CircleGroup,
	          null,
	          _react2.default.createElement(_Circle2.default, {
	            style: { position: "absolute", left: "22px", top: "15px" },
	            opacity: 0.17
	          }),
	          _react2.default.createElement(_Circle2.default, {
	            r: 8,
	            style: { position: "absolute", left: "32px", top: "32px" }
	          }),
	          _react2.default.createElement(_Circle2.default, {
	            r: 16,
	            style: { position: "absolute", left: "46px", top: "46px" },
	            opacity: 0.3
	          })
	        ),
	        _react2.default.createElement(_Circle2.default, {
	          r: 56,
	          style: { position: "absolute", right: "-34px", top: "-34px" },
	          opacity: 0.15
	        }),
	        _react2.default.createElement(_Circle2.default, {
	          r: 36,
	          style: { position: "absolute", left: "-37px", top: "20%" },
	          opacity: 0.15
	        }),
	        _react2.default.createElement(_Circle2.default, {
	          r: 100,
	          style: { position: "absolute", right: "-101px", top: "40%" },
	          opacity: 0.1
	        }),
	        _react2.default.createElement(_Circle2.default, {
	          r: 20,
	          style: { position: "absolute", left: "-21px", top: "60%" },
	          opacity: 0.15
	        }),
	        _react2.default.createElement(_Circle2.default, {
	          r: 200,
	          style: { position: "absolute", right: "-201px", top: "90%" },
	          opacity: 0.1
	        })
	      ),
	      _react2.default.createElement(_Connect2.default, {
	        mb: [5, 5, 6],
	        heading: "Want more info? We're always happy to say hello..."
	      })
	    )
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var post = data.markdownRemark;
	
	
	  return _react2.default.createElement(PageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: post.frontmatter.title,
	    content: post.html
	  });
	};
	
	// Styled Components
	
	
	var ContentBox = (0, _styledComponents2.default)(_rebass.Box)(_templateObject);
	
	var CircleGroup = _styledComponents2.default.div(_templateObject2);
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-default-page-js-7ebea1a3fc07120fc408.js